import { render } from "./Landing.vue?vue&type=template&id=574dec64"
const script = {}

import "./Landing.vue?vue&type=style&index=0&id=574dec64&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__